import React from 'react';
import { FormControlLabel, Radio as MuiRadio } from '@mui/material';
import { useTheme } from 'styled-components';
import { RadioProps } from './radio.type';

export const Radio: React.FC<RadioProps> = (props) => {
    const theme = useTheme();
    const { label, ...radioProps } = props;

    return (
        <div className="inline [&_.MuiTypography-root]:relative [&_.MuiTypography-root]:top-[-0.1rem] [&_.MuiTypography-root]:text-medium [&_.MuiTypography-root]:font-medium [&_.Mui-checked+_.MuiTypography-root]:text-brand-secondary [&_.Mui-checked+_.MuiTypography-root]:font-black">
            <FormControlLabel
                control={
                    <MuiRadio
                        {...radioProps}
                        sx={{
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.color.secondary.main,
                                fontWeight: theme.base.fontWeight,
                                fontFamily: theme.base.fontFace,
                                fontSize: theme.text.size.medium.fontSize,
                                width: '2.4rem',
                                height: '2.4rem',
                            },
                        }}
                    />
                }
                label={label}
            />
        </div>
    );
};
